/**!
 * Created by Leonardo Cheslacki on 24/11/2023.
 *
 * MIT License
 *
 * Copyright (c) 2023 cheslacki
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.

 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */

import PropTypes from 'prop-types';

import HelpersController from './../HelpersController';

let _this = {};

/**
 *
 */
class LayersPins extends HelpersController {
    /**
     *
     * @param props
     * @param main
     */
    constructor(props, main) {
        super(props);

        this.props = props;
        this.main = main;

        _this = this;
    };

    /**
     *
     * @returns {*}
     */
    get = () => {
        const {current_name} = this.props;

        return this.main.getState(`_this_${current_name}`);
    };

    /**
     *
     * @param frame
     * @param occurrence {string | boolean}
     */
    navigate = (frame, occurrence = false) => {
        const {occ_pins} = this.get();

        occ_pins.gotoAndStop(frame);

        occurrence && this.main.effectFadeIn(occ_pins, `occ_frame_${occurrence}`);
    };

    /**
     *
     */
    close = () => {
        const {default_frame} = this.props;

        this.navigate(default_frame);
    };

    /**
     *
     * @param event
     */
    show = (event) => {
        let
            {name} = event.target,
            occurrence = this.padWithLeadingZeros(name.substring(name.length - 2), 2);

        this.navigate(`frame${occurrence}`, occurrence);
    };

    /**
     *
     */
    create = () => {
        const
            {occ_pins} = this.get(),
            {totalFrames} = occ_pins;

        this.close();

        /**
         *
         *  Add event in button for paginate in frame.
         */
        for (let i = 0; i < (totalFrames - 1); i++) {
            let occurrence = this.padWithLeadingZeros((i + 1), 2);

            this.removeListener('click', `modal-${occurrence}`, this.show, () => {
                this.addListener(occ_pins[`btn_frame_${occurrence}`], 'click', `modal-${occurrence}`, this.show);
            });

            this.removeListener('click', `modal-text-${occurrence}`, this.show, () => {
                this.addListener(occ_pins[`btn_frame_text_${occurrence}`], 'click', `modal-text-${occurrence}`, this.show);
            });
        }

        this.removeListener('click', `close-modal`, this.close, () => {
            this.addListener(occ_pins.btn_close, 'click', `close-modal`, this.close);
        });
    };
}

/**
 *
 * @type {{default_frame: Requireable<string>, name: Requireable<string>, current_name: Requireable<string>}}
 */
const propTypes = {
    name: PropTypes.string,
    default_frame: PropTypes.string,
    current_name: PropTypes.string
};

/**
 *
 * @type {{default: {default_frame: string, name: string, current_name: null}}}
 */
const config = {
    default: {
        name: 'pins',
        default_frame: 'frame00',
        current_name: null
    }
};

/**
 *
 * @param _this
 * @returns {function(*): LayersPins}
 */
export default (_this) => (props) => {
    const defaultProps = {...config.default, ...props};
    PropTypes.checkPropTypes(propTypes, defaultProps, 'prop', 'LayersPins');
    return (new LayersPins(defaultProps, _this));
};